exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fl-survey-loading{width:100%;background-color:#1e3c4d;height:100vh;display:flex;align-items:center;justify-content:center}.fl-survey-loading .fl-text-loading{padding-top:10px;display:inline-block;font-weight:400;color:#fff}.fl-survey-loading .loader{border:4px solid hsla(0,0%,100%,.2);border-radius:50%;border-top:4px solid #fff;width:48px;height:48px;-webkit-animation:spin 1s linear infinite;animation:spin 1s linear infinite;margin:0 auto}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}", ""]);

// exports
